import { isNullOrUndefined, isString } from "../../store/storeFunctions";

export function computeNestedObjectsSizes(fontSize, parentLogicalSize, childLogicalSize) {
    const parentSize = Math.round(parseFloat(fontSize) * parentLogicalSize);
    const floatChildSize = parseFloat(fontSize) * childLogicalSize;
    let childSize = Math.round(floatChildSize);
    if (parentSize % 2 !== childSize % 2) {
        if (floatChildSize >= childSize) {
            childSize += 1;
        } else {
            childSize -= 1;
        }
    }
    return { parentSize, childSize };
}

export function strip(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
}

export function isIE() {
    return isNullOrUndefined(window._browser) ? /MSIE|Trident/.test(window.navigator.userAgent) : window._browser.isIE;
}

export function isEdge() {
    return isNullOrUndefined(window._browser) ? /Edge/.test(window.navigator.userAgent) : window._browser.isEdge;
}

export function isFirefox() {
    return isNullOrUndefined(window._browser) ? /Firefox/.test(window.navigator.userAgent) : window._browser.isFirefox;
}

export function getParams(query) {
    const params = new URLSearchParams(query);
    const result = Object.create(null);

    for (const [key, value] of params.entries()) {
        let decodedValue = decodeURIComponent(value);
        if (isValidKey(key) && isValidValue(decodedValue)) {
            result[key] = decodedValue;
        }
    }

    return Object.assign({}, result);
}

function isValidKey(key) {
    return isString(key) && !/['";\[\]<>%&]/.test(key);
}

function isValidValue(value) {
    return isString(value) && !/['";\[\]<>%&]/.test(value);
}

export function getDobFromPin(pin) {
    if (pin === undefined || pin === null || pin.length <= 5)
        return null;

    try {
        let year = parseInt(pin.slice(0, 2));
        let month = parseInt(pin.slice(2, 4));
        let day = parseInt(pin.slice(4, 6));

        year = year + 2000;
        month = month > 50 ? month - 51 : month - 1; // months interval is 0-11

        var date = new Date(year, month, day);
        return date > new Date() ? new Date(year - 100, month, day) : date;
    } catch {
        return null;
    }
}